var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.091,
    height: 14,
    viewBox: "0 0 19.091 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-bed-3518402_1_",
    "data-name": "noun-bed-3518402 (1)",
    d: "M77.818,209.579v-4.306A1.276,1.276,0,0,0,76.545,204h-14a1.276,1.276,0,0,0-1.273,1.273v4.306A1.705,1.705,0,0,0,60,211.212v6.364a.424.424,0,1,0,.848,0V216.3H78.242v1.273a.424.424,0,1,0,.848,0v-6.364A1.705,1.705,0,0,0,77.818,209.579Zm-15.7-4.306a.426.426,0,0,1,.424-.424h14a.426.426,0,0,1,.424.424v4.242H75.7v-2.121a.425.425,0,0,0-.424-.424H70.606a.425.425,0,0,0-.424.424v2.121H68.909v-2.121a.425.425,0,0,0-.424-.424H63.818a.425.425,0,0,0-.424.424v2.121H62.121Zm12.727,4.242H71.03v-1.7h3.818Zm-6.788,0H64.242v-1.7h3.818Zm-7.212,1.7a.851.851,0,0,1,.848-.848h15.7a.851.851,0,0,1,.848.848v1.273H60.848Zm0,2.121H78.242v2.121H60.848Z",
    transform: "translate(-60 -204)",
    fill: "#c3c3c3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomType);
export default __webpack_public_path__ + "static/media/roomType.2117bd93e07712aa4d0a5776a20b0208.svg";
export { ForwardRef as ReactComponent };